import { Injectable } from '@angular/core';
import { Segment } from '@app/models/micro/segment.model';
import { Reservation } from '@app/models/micro/reservation.model';
import { GlobalsService } from './globals.service';
import moment from 'moment';
import {
  CHECKIN_STATUS,
  FLIGHT_ITINERARY_TYPE,
  FLIGHT_STATUS,
  PAX_TYPE,
  TypeLoading,
  ESTATUS_CHECKIN,
} from '@app/enums';
import { Router } from '@angular/router';
import { MessagesService } from '../messages.service';
import { CodesError, CodesErrorDestination, TypesErrors } from '@app/enums/errors.enum';
import {
  calculateTimeFlightwithType,
  checkSegmentIsAffected,
  shouldShowIropsDisclaimer2Segments,
  hasIropsConfirmationRemark,
  validateIropsFlow,
  verifyChildAlone,
} from '@utils/functions/srIrops';
import { isStbEmployee, stbPallSeat } from '@utils/functions/stb';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../admin.service';
import { IROPS_STATUS } from '@app/enums/irops.enum';
import { IropsService } from '../irops.service';
import { IropsMapper } from '@app/mappers';
import { ApiService } from '@services/micro/api.service';
import { ViewDocuments } from '@models/micro/response/viewDocuments.model';
import { ErrorInt } from '@interfaces/*';
import {
  messageParamsGeneric,
  messageNoCkn,
  messageBaggageOnlyNoCki,
  messageBaggageOnlyNoBags,
  evaluateFemModal,
  buildFemMetricPayload,
  isNoItineraryError,
  messageNoItinerary,
} from '@app/utils';
import { NewRelicEventsService } from '@app/services/new-relic-events.service';
import { NEW_RELIC_EVENT } from '@app/enums/new-relic.enum';
import {
  getTypeFlowIrops,
  isClosed,
  isClosedMYB,
  isFlightAlreadyDeparted,
} from '@utils/functions/general';
import { PassengerService } from './passenger.service';
import { combineLatest, lastValueFrom, of, take, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FlightDetails } from '@models/micro/response/flightDetails.model';
import { Ga4Service } from '@app/services/ga4.service';
import { AirLinesComponent } from '@modals/air-lines/air-lines.component';
import { AmKeyboardService } from '@components/am-keyboard/am-keyboard.service';
import { LoadingService } from '../loading.service';
import { Passenger } from '@app/models/micro/passenger.model';
import { AirLineSeamless } from '@app/utils/constants/airlineSeamless';
import { VerifyPassportModalComponent } from '@modals/verify-passport-modal/verify-passport-modal.component';
import { LoyaltyService } from '@services/micro/loyalty.service';
import { OK_TO_BOARD } from '@app/utils/constants/generals';
import { IropsService as IropsMicroService } from './irops.service';
import { RequiredDocumentsService } from './required-documents.service';
import { GetViewDocumentsRetryService } from './get-view-documents-retry.service';
import { PassengerIdMapService } from '@services/passenger-id-map.service';
import { TsaBlockerModalComponent } from '@app/shared/modals/tsa-blocker-modal/tsa-blocker-modal.component';
import { environment } from 'src/environments/environment';
import { FemModalComponent } from '@modals/fem-modal/fem-modal.component';
import { isHavanaFlight } from '@app/utils';
import { HavanaBlockModalComponent } from '@shared/modals/havana-block-modal/havana-block-modal.component';
import { ErrorModel } from '@app/models/micro/error.model';
import { TranslateService } from '@ngx-translate/core';
import { PNRLookupAWSInt } from '@app/interfaces/reservation-aws.interface';
import { IropsAccessRegistryService } from './irops-access-registry.service';
import { QuantumMetricService } from '@services/quantum-metric.service';
import { CdcAttestationService } from './cdc-attestation.service';
/**
 *Servicio para gestionar el proceso de búsqueda de PNR (Passenger Name Record), que incluye la comprobación del estado del vuelo,
 * la gestión de reservas y el manejo de casos especiales como pasajeros en lista de espera, pasajeros menores de edad y operaciones irregulares (IROPS).
 * Este servicio interactúa con varias API para obtener detalles del vuelo, documentos y listas de pasajeros, así como para mostrar los modales apropiados
 * y redirigir al usuario a la página correspondiente en función del estado del vuelo y los pasajeros.
 *
 */

@Injectable({
  providedIn: 'root',
})
export class LookUpPnrService {
  reservation: Reservation | null = null;
  selectedSegment: Segment | null = null;
  pnrLookupFailureCount = 0;
  showModalIrops = false;
  redirect: boolean = false;
  subscribeReference: Subscription;
  respEligibleIrops: any;
  reservationInt: PNRLookupAWSInt;
  environment = environment;
  shouldBlockByMissingPassengerIds = false;

  constructor(
    private readonly _globalService: GlobalsService,
    private readonly _router: Router,
    private readonly _message: MessagesService,
    private readonly modalService: NgbModal,
    private readonly _adminService: AdminService,
    private readonly _iropsService: IropsService,
    private readonly _apiService: ApiService,
    private readonly _loyatlyService: LoyaltyService,
    private readonly _passengerService: PassengerService,
    private readonly _ga4Service: Ga4Service,
    private readonly _keyboardServ: AmKeyboardService,
    private readonly _loadingService: LoadingService,
    private readonly _iropsMicroService: IropsMicroService,
    private readonly _requiredDocuments: RequiredDocumentsService,
    private readonly _traslateService: TranslateService,
    private iropsAccessRegistry: IropsAccessRegistryService,
    private readonly _getViewDocumentsRetryService: GetViewDocumentsRetryService,
    private readonly _passengerIdMapService: PassengerIdMapService,
    private readonly _quantumMetricService: QuantumMetricService,
    private readonly _newRelicEventsService: NewRelicEventsService,
    private readonly _cdcAttestationService: CdcAttestationService
  ) {}
  /**
  Realiza una serie de operaciones relacionadas con la búsqueda y procesamiento de una reserva de vuelo (PNR).
  Esta función configura sesiones en herramientas de análisis, valida la aerolínea operadora, realiza solicitudes
  a microservicios para obtener información adicional, gestiona el estado de check-in y determina la redirección
  basada en el tipo de itinerario.

  @param lookUp Un arreglo de objetos de tipo `Reservation` que contiene la información de la reserva de vuelo.
  @return No retorna ningún valor explícito, pero realiza redirecciones y actualizaciones en servicios globales.
**/

  successLookUpPnr = async (lookUp: Reservation[]) => {
    // CA1: Bloquear navegación con FULL_LOADING hasta tener respuesta completa de microservicios
    this._loadingService.showLoading(TypeLoading.FULL_LOADING);

    const { Location } = this._adminService.admin;
    const { hasConfirmed } = this._iropsMicroService;

    if (this.validInternationalBlock(lookUp[0])) {
      this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
      this.openModalInternationalBlocked();
      /*this._message.error({}, '', TypesErrors.TSA_VALIDATION, {
        colorFontButton: "white-font",
        buttonCopy: 'footer.continue'
      }).finally(() => {
        this._router.navigate(['/'])
      })*/
      //this.ngOnDestroy();
      return;
    }

    if (isHavanaFlight(lookUp[0]?.flightSummary?.segments)) {
      this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
      this.openHavanaBlockModal();
      return;
    }

    this._ga4Service.sendSessionStarEvent('session_start_am', 'PNR_lookup');
    // Activa Seamless
    if (lookUp[0]?.flightSummary?.operatingCarrier != 'AM' && !this.isSeamless(lookUp[0])) {
      this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
      this.openCodeInfoModal(lookUp[0]?.flightSummary?.operatingCarrier);
      this.ngOnDestroy();
      return;
    }

    this._quantumMetricService.startSession(); // QM: one recording per found reservation

    this._globalService.setPNRLookUp(lookUp);
    this.reservation = lookUp[0];

    // If the flag is disabled from the admin panel, the `isConfirmatedByARU`
    // property from the PNR should not be read or considered.
    if (!this._adminService.admin.showAruExperience) {
      this.reservation.isConfirmatedByARU = false;
    }

    this._globalService.setReservation(this.reservation);
    this._adminService.admin.cartId = this.reservation.flightSummary.cartId;

    // CI-21913: Skipear validateVoidTicket para PNRs con SC/WK/EXCH porque el cupón
    // apunta al segmentCode viejo (pre-schedule change) y la validación lo interpreta como void.
    const hasScheduleChange = this.reservation.flightSummary?.segments?.some((s) =>
      ['SC', 'WK', 'EXCH'].includes(s.segmentStatusCode)
    );

    if (!hasScheduleChange && this.validateVoidTicket(this.reservation)) {
      this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
      this._message
        .errorNoCkin(
          {
            typesError: TypesErrors.CHECKIN_ERROR,
            error: {
              message: '',
            },
          },
          null,
          TypesErrors.CHECKIN_ERROR,
          messageNoCkn,
          '',
          false
        )
        .finally(() => {
          this._router.navigate(['']);
        });
      return;
    }

    if (
      this.reservation.flightSummary.windowLegStatus !== 'CKI' &&
      isClosedMYB(this.reservation.flightSummary, this.reservation.flightSummary.currentSegment)
        .status === true
    ) {
      const childRoute = this.isChildAlone(this.reservation?.passengers);
      if (childRoute) {
        this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
        this._router.navigate([childRoute]);
        return;
      }
      const response = await this.getViewDocumentsWithRetry(
        this.reservation,
        this.successGetDocuments.bind(this)
      );
      if (response) {
        if (this.handleMissingPassengerIdsBlock()) {
          this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
          return;
        }
        this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
        this._router.navigate(['/notice-myb-closed']);
      }
      return;
    }

    const flowIrops = getTypeFlowIrops(this.reservation);
    if (flowIrops) {
      if (flowIrops === 'commercial') {
        if (this._adminService.admin.baggageOnlyFlow) {
          this._message
            .errorNoCkin(
              { typesError: TypesErrors.BAGGAGE_ONLY_NO_CKI, error: null },
              null,
              TypesErrors.BAGGAGE_ONLY_NO_CKI,
              messageBaggageOnlyNoCki
            )
            .finally(() => {
              this._router.navigate(['']);
            });
          return;
        }

        // CI-21913: SC/WK/EXCH → auto-confirmar a HK sin pasar por pantalla IROPS.
        if (!this._iropsMicroService.hasConfirmed) {
          try {
            await lastValueFrom(
              this._iropsMicroService.confirmScheduleChangeToHk(this.reservation)
            );
            // Éxito: re-lookup del PNR (ahora tiene HK) y re-procesar
            const relookup = await lastValueFrom(
              this._apiService.getReservation('PNR', '', '', '', '', '', this.reservation.pnr)
            );
            await this.successLookUpPnr(relookup);
            return;
          } catch (error) {
            // Backend rechazó la confirmación → fallback al flujo IROPS estándar
            try {
              this.respEligibleIrops = await this.dispatchEligibilityIrops();
              this.dispatchIropsRemarkIfEligible();
            } catch (eligError) {
              // noop — Si eligibility también falla, seguir al iropsRebrand de todas formas
            }
            this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
            this._router.navigate(['/srIrops/iropsRebrand']);
            return;
          }
        }
      } else {
        // Agregar a función Try y eliminar este else
        try {
          const requestMicro = IropsMapper.requestIropsMicro(lookUp);

          const responseMicro = await this._iropsService.makeRequestIropsMicro(requestMicro);

          if (!responseMicro || responseMicro.length === 0) {
            throw new Error('No se recibió respuesta válida del Micro IROPS');
          }

          this.constructFlight(responseMicro, lookUp);
        } catch (error) {
          this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
        }
      }
    }

    const hasRealAffectation = validateIropsFlow(this.reservation, Location, hasConfirmed);
    const hasCheckedInPassengers = this.reservation.passengers.some((p) =>
      p.ticketInfo?.coupons?.some((c) => c.couponStatus === 'CKIN')
    );

    // El PNR conserva isConfirmatedByARU incluso despues de que el pasajero acepta y mantiene su
    // vuelo, y hasConfirmed (en memoria) se limpia con resetIropsState() al volver a empezar. El
    // unico rastro duradero de la aceptacion es el remark CONFIT/SCH2HK que se escribe en el PNR,
    // asi que se consulta aqui para no reenviar al pasajero a la pantalla ARU en cada consulta.
    const hasAcceptedIropsFlight = hasIropsConfirmationRemark(this.reservation);

    if (
      this.reservation.isConfirmatedByARU &&
      !hasRealAffectation &&
      !hasCheckedInPassengers &&
      !hasAcceptedIropsFlight
    ) {
      this._globalService.setReservation(this.reservation);
      this._router.navigate(['/srIrops/iropsRebrand'], {
        state: { aruWithoutFlightStatus: true },
      });
      return;
    }

    // AQUI ED CODE
    /*
      if (IGUAL a CLOSED  &&  Si tiene afectación && banderaDeYisus/remark )
      {
        //setear flightSummary y currentSegment
        //flowIrops === 'operational'
      }
    */

    if (
      flowIrops === 'operational' &&
      validateIropsFlow(this.reservation, Location, hasConfirmed)
    ) {
      try {
        this.respEligibleIrops = await this.dispatchEligibilityIrops();
        this.dispatchIropsRemarkIfEligible();
      } catch (error) {
        this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
      }
    }

    const mybStatus = isClosedMYB(this.reservation.flightSummary);
    if (this.reservation.flightSummary.windowLegStatus !== 'CKI' && mybStatus.status === true) {
      if (this.redirect) {
        this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
        this._globalService.isFlowMYBClosed = false;
        this._router.navigate(['/notice-myb-closed']);
      }
      return;
    }

    const { flightItineraryType } = this.reservation;
    if (this.reservation.checkinStatus !== CHECKIN_STATUS.CLOSED) {
      const response = await this.getViewDocumentsWithRetry(
        this.reservation,
        this.successGetDocuments.bind(this)
      );
      if (!response) {
        return;
      }
      await this.loadStb(this.reservation);
    }
    let urlDirect = '';

    switch (flightItineraryType) {
      case FLIGHT_ITINERARY_TYPE.ONEWAY:
        const segments = this.reservation.flightSummary.segments;
        const shouldShowIrops2Seg =
          segments.length === 2
            ? shouldShowIropsDisclaimer2Segments({
                segments: segments.map((seg) => ({
                  isChangeOag: seg.isChangeOag,
                  isCancelOag: seg.isCancelOag,
                  segmentStatus: seg.segmentStatusCode,
                  segmentCode: seg.segmentCode,
                  windowSegmentStatus: seg.windowSegmentStatus,
                })),
                currentSegment: {
                  segmentCode: this.reservation.flightSummary.currentSegment?.segmentCode,
                },
                confirmedSegmentCodes: this.getConfirmedSegmentCodes(),
              })
            : validateIropsFlow(this.reservation, Location, hasConfirmed);
        if (shouldShowIrops2Seg && !this._adminService.admin.baggageOnlyFlow) {
          this._globalService.setReservation(this.reservation);
          const segmentCancelled = this.segCancelled;
          const segmentAfected = this.segAfected;
          const diffMinutes = Math.abs(
            segmentAfected?.flightsNewInfo?.departureDifferenceInMinutes || 0
          );
          const timeAfected = {
            hours: Math.floor(diffMinutes / 60),
            minutes: diffMinutes % 60,
            status:
              segmentAfected?.flightsNewInfo?.status === IROPS_STATUS.DELAYED ? 'DELAYED' : 'AHEAD',
          };

          // Validación según el status
          const shouldShowIrops =
            segmentAfected?.flightsNewInfo?.status === IROPS_STATUS.EARLY
              ? timeAfected.minutes >= 15 || timeAfected.hours > 0 // EARLY: >= 15 min
              : timeAfected.minutes >= 30 || timeAfected.hours > 0; // DELAYED: >= 30 min

          urlDirect = '/srIrops/iropsRebrand';

          // Si el vuelo ya despegó (hora recalculada ya pasó), mostrar Vuelo Cerrado
          if (isFlightAlreadyDeparted(this.reservation)) {
            const validIsClosed = isClosed(
              this.reservation.flightSummary,
              this.reservation.flightSummary.currentSegment
            );
            urlDirect = validIsClosed ? '/notice-closed-onboarding' : '/notice-closed';
          } else if (
            !segmentCancelled &&
            segmentAfected &&
            !this.reservation?.isEmployee &&
            this.respEligibleIrops &&
            !this.respEligibleIrops?.exchangesAllowed
          ) {
            if (this.reservation.checkinStatus === CHECKIN_STATUS.CLOSED) {
              const validIsClosed = isClosed(
                this.reservation.flightSummary,
                this.reservation.flightSummary.currentSegment
              );
              urlDirect = validIsClosed ? '/notice-closed-onboarding' : '/notice-closed';
            } else if (!shouldShowIrops) {
              urlDirect = '/choose-passagers';
            } else {
              this.reservation.iropsElegibility = false;
              this._globalService.setReservation(this.reservation);
            }
          } else if (
            segmentCancelled &&
            !this.reservation?.isEmployee &&
            this.respEligibleIrops &&
            !this.respEligibleIrops?.exchangesAllowed
          ) {
            this.reservation.iropsElegibility = this.respEligibleIrops?.exchangesAllowed;
            this._globalService.setReservation(this.reservation);
          } else {
            const validIsClosed = isClosed(
              this.reservation.flightSummary,
              this.reservation.flightSummary.currentSegment
            );

            if (segmentAfected && !shouldShowIrops) {
              if (this.reservation.checkinStatus === CHECKIN_STATUS.CLOSED) {
                urlDirect = validIsClosed ? '/notice-closed-onboarding' : '/notice-closed';
              } else {
                const response = await this.getViewDocumentsWithRetry(
                  this.reservation,
                  this.successGetDocuments.bind(this)
                );
                if (!response) {
                  return;
                }
                await this.loadStb(this.reservation);
                urlDirect = this.validatePassengersCki();
              }
            }
          }
        } else {
          let trip: any = lookUp[0].flightSummary.segments[0];
          this._globalService.setSelectedTrip(trip);
          urlDirect = await this.redirectCases(this.reservation, lookUp);
        }
        break;
      case FLIGHT_ITINERARY_TYPE.ROUNDTRIP:
      case FLIGHT_ITINERARY_TYPE.MULTICITY:
        let tripSelected: Segment | null;
        const openTrips = lookUp[0].checkinStatus == 'OPEN' ? lookUp : null;
        tripSelected = lookUp.reverse()[0].flightSummary.segments[0];
        this._globalService.setSelectedTrip(tripSelected);
        if (openTrips?.length > 1) {
          this._globalService.isMultiFlights = true;
          urlDirect = await this.resolveIropsRouteOrDefault('/choose-passagers');
        } else {
          if (openTrips?.length > 0) {
            this._globalService.setReservation(openTrips[0]);
          }
          urlDirect = await this.redirectCases(this.reservation, lookUp);
        }
        break;
    }

    if (this.redirect) {
      if (this.handleMissingPassengerIdsBlock()) {
        this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
        return;
      }

      // Paso 2: Guard de integridad — validar datos mínimos antes de navegar
      // true ||
      if (
        !this.reservation?.pnr ||
        !this.reservation?.passengers?.length ||
        !this.reservation?.flightSummary?.legCode
      ) {
        this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
        this._message
          .error({}, null, 'syncError.missingData', {
            showButton: true,
            buttonCopy: 'errorMsj.msj.button',
          })
          .finally(() => this._router.navigate(['/']));
        return;
      }

      // CI-23290: declaracion de salud CDC, primera pantalla antes de cualquier flujo.
      if ((await this._cdcAttestationService.run(this.reservation)) === 'counter') {
        this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
        this._globalService.clearAll();
        this._router.navigate(['/']);
        return;
      }

      if (urlDirect === 'rbmenuPassengerSelection') {
        this.navigateWithFEMCheck(urlDirect);
        return;
      }

      if (this.handleBaggageOnlyNoEligiblePassengers(urlDirect)) {
        this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
        return;
      }

      if (this.handleBaggageOnlyConnectionRestriction(urlDirect)) {
        this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
        return;
      }

      if (urlDirect === '/choose-passagers') {
        const passengers = this.reservation.passengers.filter((p) => p.paxType !== PAX_TYPE.INFANT);
        const restrictedPax = passengers.filter((p) => p.checkInRestrictedByAuthority);
        if (restrictedPax.length > 0) {
          const allRestricted = restrictedPax.length === passengers.length;
          const showAsSingle = passengers.length === 1 || allRestricted;
          try {
            await this._message.showAuthorityRestrictionModal(showAsSingle ? 1 : passengers.length);
            if (showAsSingle) {
              this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
              this._globalService.clearAll();
              this._router.navigate(['/']);
              return;
            }
          } catch (_) {
            // ignore
          }
        }
      }

      this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
      this._router.navigate([urlDirect]);
    }
  };

  get segCancelled() {
    return this.reservation.flightSummary.segments.find(
      (seg) => checkSegmentIsAffected(seg) && seg?.flightsNewInfo?.status == IROPS_STATUS.CANCELLED
    );
  }

  get segAfected() {
    const acceptStatus = ['CKI', 'MYB', 'IN_FLIGHT', 'CLOSED'];
    const segments = this.reservation.flightSummary.segments;
    const currentSegment = this.reservation.flightSummary.currentSegment;
    const currentIndex = currentSegment
      ? segments.findIndex((s) => s.segmentCode === currentSegment.segmentCode)
      : 0;
    const fromIndex = currentIndex >= 0 ? currentIndex : 0;

    return segments.find(
      (seg, index) =>
        checkSegmentIsAffected(seg) &&
        (seg?.flightsNewInfo?.status == IROPS_STATUS.DELAYED ||
          seg?.flightsNewInfo?.status == IROPS_STATUS.EARLY) &&
        acceptStatus.includes(seg?.windowSegmentStatus) &&
        index >= fromIndex
    );
  }

  /**
   * Derives the list of segment codes where at least one passenger is already
   * confirmed (checked in) based on coupon status 'CKIN'.
   */
  private getConfirmedSegmentCodes(): string[] {
    const passengers = this.reservation?.passengers || [];
    const confirmedCodes = new Set<string>();

    for (const passenger of passengers) {
      const coupons = passenger?.ticketInfo?.coupons || passenger?.coupons || [];
      for (const coupon of coupons) {
        if (coupon?.couponStatus === 'CKIN' && coupon?.segmentCode) {
          confirmedCodes.add(coupon.segmentCode);
        }
      }
    }

    return Array.from(confirmedCodes);
  }

  /**
  Maneja los errores que ocurren durante la búsqueda de un PNR (Reserva de Vuelo).
  Esta función identifica el tipo de error basado en la respuesta recibida, construye un objeto de error
  y muestra un mensaje de error apropiado al usuario.

  @param error Objeto que contiene la información del error ocurrido durante la búsqueda del PNR.
  @param pnr El código PNR (Reserva de Vuelo) que se estaba buscando cuando ocurrió el error.
**/

  errorLookUpPnr = (error: ErrorModel, pnr: string) => {
    let codeError = '';

    // Verificar si es una excepción FARELOCK en los datos raw
    if (error?.getRaw()?.typeReservation === 'FARELOCK') {
      this._message.errorMessage({ typesError: TypesErrors.FARELOCK_ERROR }, () => {
        this._router.navigate(['/']);
      });
      return;
    }

    if (error?.getMessage()?.includes('NOT_FOUND')) {
      codeError = '204131-2';
    }
    if (error?.getMessage()?.includes('MANY')) {
      codeError = '204131-1';
    }

    if (error?.getMessage()?.includes('NO_RESERVATIONS')) {
      codeError = '204131';
    }
    error.withCode(codeError);

    const objError: ErrorInt = {
      error: {
        code: codeError,
      },
      code: codeError,
    };

    if (this.isCodeError(codeError)) {
      this._message.errorMessageDestination({ error });
    } else if (this.isCodeErrorDestination(codeError)) {
      this._message.errorMessageDestination({ error });
      this._message.printErrorCard(TypesErrors.DEST_SEARCH_FAIL, error);
    } else {
      this._message.error(
        { typesError: TypesErrors.RESERVATION_NOT_FOUND, error },
        error.getCode(),
        TypesErrors.RESERVATION_NOT_FOUND,
        messageParamsGeneric
      );
    }
  };

  private isCodeError(code: string): code is CodesError {
    return Object.values(CodesError).includes(code as CodesError);
  }

  private isCodeErrorDestination(code: string): code is CodesErrorDestination {
    return Object.values(CodesErrorDestination).includes(code as CodesErrorDestination);
  }

  isNoItineraryError(error: any): boolean {
    return isNoItineraryError(error);
  }

  showNoItineraryModal(): void {
    this._message
      .errorNoCkin(
        { typesError: TypesErrors.NO_ITINERARY_ERROR, error: null },
        null,
        TypesErrors.NO_ITINERARY_ERROR,
        messageNoItinerary
      )
      .finally(() => {
        this._router.navigate(['']);
      });
  }

  sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

  /**
  Obtiene los detalles de un vuelo específico asociado a una reserva y actualiza la información de los segmentos de la reserva.
  Esta función realiza una solicitud para obtener los detalles del vuelo y, si tiene éxito, actualiza la información
  de los segmentos de la reserva con los datos del estado del vuelo.

  @param reservation Un objeto de tipo `Reservation` que representa la reserva de vuelo para la cual se obtendrán los detalles.
  @return No retorna ningún valor explícito, pero actualiza la reserva en el servicio global.
**/

  getFlightDetails(reservation: Reservation) {
    this._apiService.getFlightDetails(reservation).subscribe({
      next: (res) => {
        let reponse = new FlightDetails(res);
        for (let segment of reservation.segments) {
          const segmentAct = reponse.bookedLegCollection.find(
            (p) => p.segmentCode == segment.segmentCode
          );
          if (segmentAct) {
            const cabinInfo = segmentAct.cabinInfoList.find((p) => p.classOfService == 'Y');
            segment.cabinInfo = cabinInfo;
            segment.flightStatus = segmentAct.flightStatus;
          }
        }
        this._globalService.setReservation(reservation);
      },
      error: (error: ErrorModel) => {
        this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
        this._message.printErrorCard(
          error.getCodeNumber(),
          error,
          reservation.pnr,
          reservation,
          reservation.passengers,
          error.getMessage()
        );
      },
      complete: () => {},
    });
  }

  /**
   * Obtiene y asigna los documentos requeridos para la reserva.
   *
   * @param {Reservation} reservation - Objeto de la reserva actual.
   * @returns {Promise<boolean>} - Promesa que se resuelve en `true` si el proceso es exitoso, de lo contrario se rechaza con `false`.
   */

  successGetDocuments(res) {
    let reponse = new ViewDocuments(res);
    const isDomestic = this.reservation?.flightSummary.isDomestic || false;
    const bookedLegCollection = reponse?.bookedLegCollection.find(
      (book) => book.legCode == this.reservation.flightSummary.legCode
    );
    const codeShare = bookedLegCollection?.codeShare || false;

    //#region set Reservartion seamless
    this.reservation.codeShare = codeShare;

    this.shouldBlockByMissingPassengerIds = this.hasNoPassengerIdsForAllPassengers(reponse);

    this.reservation.travelPartyId = reponse.travelPartyId;
    this.reservation.mandates = reponse.mandates;
    this.reservation.trips = reponse.trips;
    //#endregion set Reservartion seamless

    //#region set Leg seamless
    this.reservation.flightSummary.codeShare = codeShare;
    this.reservation.flightSummary.sdsProvider = bookedLegCollection.sdsProvider;
    this.reservation.flightSummary.serviceCodeShareEnable =
      bookedLegCollection.serviceCodeShareEnable;
    //#endregion set Leg seamless
    let passengerId;
    for (let passeger of this.reservation.passengers) {
      const passegerdoc = reponse.passengers.find(
        (p) => p.passengerNameNumber == passeger.nameRefNumber
      );
      //set passenger seamless
      if (this.reservation.codeShare) {
        passeger.passengerIdSkyteam = passegerdoc?.passengerIdSkyteam;
        passengerId = passeger.id;
        passeger.passengerIds = [];
        passeger.sourceMissing = passegerdoc.sourceMissing;

        passeger.checkinStatus = passegerdoc.checkinStatus == 'CHECKED_IN';
        passeger.passengerInfo.destinationAddress = passegerdoc.destinationAddress;
        passeger.passengerInfo.contactEmergency = passegerdoc.contactEmergency;
        passeger.passengerInfo.passport = passegerdoc.passport?.expirationDate
          ? passegerdoc.passport
          : undefined;
        passeger.passengerInfo.timaticRQ = passegerdoc.timaticRQ;
        passeger.passengerInfo.residenceAddress = passegerdoc.residenceAddress;
        passeger.passengerInfo.visa = passegerdoc.visa;
        passeger.passengerInfo.countryResidence = passegerdoc.countryResidence;
      } else {
        //set passenger not seamless
        passeger.applyDocumentPassengerIds(
          passegerdoc.passengerIds,
          this.reservation?.flightSummary?.currentSegment?.segmentCode
        );
        passengerId = passeger.passengerId;
      }
      passeger.passengerInfo.timaticRQ = passegerdoc.timaticRQ;
      passeger.missingCheckinRequiredFields = [];
      passeger.passengerId = passengerId;
      passeger.freeTextInfoList = passegerdoc.freeTextInfoList;
      passeger.requiredInfoList = passegerdoc.requiredInfoList;
      passeger.sprinklr = passegerdoc?.sprinklr;
      passeger.missingCheckinOptionalFields = passegerdoc.missingCheckinOptionalFields ?? [];
      passeger.hasDOCV = passegerdoc?.hasDOCV ?? false;

      if (passeger.passengerInfo?.passport && passegerdoc?.passport) {
        passeger.passengerInfo.passport.passportScanned =
          passegerdoc.passport.passportScanned ?? false;
      }

      if (!isDomestic) {
        this._passengerService.buildMissingCheckinRequiredFields(passeger, passegerdoc, reponse);

        if (passegerdoc?.timaticInfoList?.length > 0) {
          if (passegerdoc?.timaticInfoList[0]?.timaticStatus == OK_TO_BOARD) {
            passeger.isOkToBoard = true;
          }
        }
      }
    }

    // Upsert resolved passenger IDs into session backup mapping
    const passengerIdEntries = this.reservation.passengers
      .filter((p) => p.passengerIds && p.passengerIds.length > 0 && p.passengerId)
      .map((p) => ({
        passengerNameNumber: p.nameRefNumber,
        passengerId: p.passengerId,
        passengerIds: p.passengerIds,
      }));
    this._passengerIdMapService.upsert(passengerIdEntries);

    this._globalService.setReservation(this.reservation);
  }

  /**
   * Resuelve la URL de destino para el ramal multi-open-trip de ROUNDTRIP/MULTICITY evaluando
   * las mismas condiciones IROPS que la rama ONEWAY (validateIropsFlow, segAfected,
   * segCancelled, respEligibleIrops y el umbral DELAYED >= 30 min / EARLY >= 15 min).
   *
   * @param defaultUrl URL por defecto a devolver cuando no aplica ninguna ruta IROPS.
   * @return '/srIrops/iropsRebrand', '/srIrops/noElegibleSR' o el `defaultUrl` recibido.
   */
  private async resolveIropsRouteOrDefault(defaultUrl: string): Promise<string> {
    const { Location } = this._adminService.admin;
    const { hasConfirmed } = this._iropsMicroService;

    if (!validateIropsFlow(this.reservation, Location, hasConfirmed)) {
      return defaultUrl;
    }

    if (this._adminService.admin.baggageOnlyFlow) {
      return defaultUrl;
    }

    this._globalService.setReservation(this.reservation);
    const segmentCancelled = this.segCancelled;
    const segmentAfected = this.segAfected;
    const firstAfectedTime =
      segmentAfected?.flightsNewInfo?.originalDepartureTime || segmentAfected?.departureDateTime;
    const timeAfected = calculateTimeFlightwithType(
      firstAfectedTime,
      segmentAfected?.flightsNewInfo?.departureDateTime,
      segmentAfected?.flightsNewInfo?.status
    );

    // Validación según el status: EARLY >= 15 min, DELAYED >= 30 min (cualquier hours > 0)
    const shouldShowIrops =
      segmentAfected?.flightsNewInfo?.status === IROPS_STATUS.EARLY
        ? timeAfected.minutes >= 15 || timeAfected.hours > 0
        : timeAfected.minutes >= 30 || timeAfected.hours > 0;

    if (
      !segmentCancelled &&
      segmentAfected &&
      !this.reservation?.isEmployee &&
      this.respEligibleIrops &&
      !this.respEligibleIrops?.exchangesAllowed
    ) {
      return shouldShowIrops ? '/srIrops/noElegibleSR' : defaultUrl;
    }

    if (segmentAfected && !shouldShowIrops) {
      return defaultUrl;
    }

    // Si el vuelo ya despegó (hora recalculada ya pasó), mostrar Vuelo Cerrado
    if (isFlightAlreadyDeparted(this.reservation)) {
      const validIsClosed = isClosed(
        this.reservation.flightSummary,
        this.reservation.flightSummary.currentSegment
      );
      return validIsClosed ? '/notice-closed-onboarding' : '/notice-closed';
    }

    return '/srIrops/iropsRebrand';
  }

  /**
  Determina la ruta de redirección basada en el estado de la reserva y otras condiciones.
  Esta función evalúa múltiples condiciones relacionadas con el estado de la reserva, como el flujo IROPS,
  el estado de check-in, la ubicación, la presencia de menores no acompañados, y si la reserva es en modo standby.
  Dependiendo de estas condiciones, devuelve la ruta correspondiente para redirigir al usuario.

  @param reservation Un objeto de tipo `Reservation` que representa la reserva actual.
  @param lookUp Un arreglo que contiene la lista de reservas o información adicional relacionada.
  @return Una cadena que representa la ruta a la que se debe redirigir al usuario.
**/

  private async redirectCases(reservation: Reservation, lookUp: any) {
    this._globalService.isFlowMYBClosed = false;
    const { Location } = this._adminService.admin;
    const { hasConfirmed } = this._iropsMicroService;
    const validateIropsFlow_ = validateIropsFlow(reservation, Location, hasConfirmed);

    // Validación de estación: bloquear si el aeropuerto de origen no coincide con la ubicación del kiosko,
    // EXCEPTO cuando hay afectación IROPS activa
    // (el pasajero puede estar en otro aeropuerto por la afectación y el kiosko está configurado para atenderlo).
    const hasPreviousIropsAccess = this.iropsAccessRegistry.has(reservation.pnr);
    const iropsAllowsDifferentStation = validateIropsFlow_ || hasPreviousIropsAccess;
    if (reservation.flightSummary.departureAirport !== Location && !iropsAllowsDifferentStation) {
      return isClosed(reservation.flightSummary, reservation.flightSummary.currentSegment)
        ? '/notice-closed-onboarding'
        : '/notice-closed';
    }

    // Reingreso directo: si el PNR ya fue identificado como elegible para IROPS previamente
    // y no hay flujo IROPS activo (validateIropsFlow_ es false), redirigir directamente a IROPS.
    if (hasPreviousIropsAccess && !validateIropsFlow_) {
      return '/srIrops/iropsRebrand';
    }
    if (validateIropsFlow_ && !this._adminService.admin.baggageOnlyFlow) {
      this._globalService.setReservation(reservation);
      const segmentCancelled = this.segCancelled;
      const segmentAfected = this.segAfected;
      const diffMinutes = Math.abs(
        segmentAfected?.flightsNewInfo?.departureDifferenceInMinutes || 0
      );
      const timeAfected = {
        hours: Math.floor(diffMinutes / 60),
        minutes: diffMinutes % 60,
        status:
          segmentAfected?.flightsNewInfo?.status === IROPS_STATUS.DELAYED ? 'DELAYED' : 'AHEAD',
      };
      // Validación específica según el status
      const shouldShowIrops =
        segmentAfected?.flightsNewInfo?.status === IROPS_STATUS.EARLY
          ? timeAfected.minutes >= 15 || timeAfected.hours > 0 // EARLY: >= 15 min
          : timeAfected.minutes >= 30 || timeAfected.hours > 0; // DELAYED: >= 30 min

      if (
        !segmentCancelled &&
        segmentAfected &&
        !this.reservation?.isEmployee &&
        this.respEligibleIrops &&
        !this.respEligibleIrops?.exchangesAllowed
      ) {
        if (this.reservation.checkinStatus === CHECKIN_STATUS.CLOSED) {
          const validIsClosed = isClosed(
            this.reservation.flightSummary,
            this.reservation.flightSummary.currentSegment
          );
          return validIsClosed ? '/notice-closed-onboarding' : '/notice-closed';
        } else if (!shouldShowIrops) {
          return '/choose-passagers';
        } else {
          this.reservation.iropsElegibility = false;
          this._globalService.setReservation(this.reservation);
        }
      } else if (
        segmentCancelled &&
        !this.reservation?.isEmployee &&
        this.respEligibleIrops &&
        !this.respEligibleIrops?.exchangesAllowed
      ) {
        this.reservation.iropsElegibility = this.respEligibleIrops?.exchangesAllowed;
        this._globalService.setReservation(this.reservation);
      } else {
        const validIsClosed = isClosed(
          this.reservation.flightSummary,
          this.reservation.flightSummary.currentSegment
        );

        if (segmentAfected && !shouldShowIrops) {
          if (this.reservation.checkinStatus === CHECKIN_STATUS.CLOSED) {
            return validIsClosed ? '/notice-closed-onboarding' : '/notice-closed';
          } else {
            const response = await this.getViewDocumentsWithRetry(
              this.reservation,
              this.successGetDocuments.bind(this)
            );
            if (!response) {
              return '';
            }
            await this.loadStb(this.reservation);
            return this.validatePassengersCki();
          }
        }
      }

      // Si el vuelo ya despegó (hora recalculada ya pasó), mostrar Vuelo Cerrado
      if (isFlightAlreadyDeparted(this.reservation)) {
        const validIsClosedDeparted = isClosed(
          this.reservation.flightSummary,
          this.reservation.flightSummary.currentSegment
        );
        return validIsClosedDeparted ? '/notice-closed-onboarding' : '/notice-closed';
      }

      return '/srIrops/iropsRebrand';
    } else if (
      reservation.flightSummary.windowLegStatus !== 'CKI' &&
      isClosedMYB(reservation.flightSummary, reservation.flightSummary.currentSegment).status ==
        true
    ) {
      const childRoute = this.isChildAlone(reservation?.passengers);
      if (childRoute) return childRoute;
      const response = await this.getViewDocumentsWithRetry(
        this.reservation,
        this.successGetDocuments.bind(this)
      );
      if (!response) {
        return '';
      }
      return '/notice-myb-closed';
    } else {
      const childRoute = this.isChildAlone(reservation?.passengers);
      if (childRoute) return childRoute;
    }

    const typeIrops = getTypeFlowIrops(reservation);
    if (
      ((typeIrops == 'operational' || !typeIrops || isFlightAlreadyDeparted(reservation)) &&
        (reservation.checkinStatus === CHECKIN_STATUS.CLOSED ||
          isClosed(reservation.flightSummary, reservation.flightSummary.currentSegment))) ||
      (!validateIropsFlow_ && reservation.flightSummary.departureAirport != Location)
    ) {
      return isClosed(reservation.flightSummary, reservation.flightSummary.currentSegment)
        ? '/notice-closed-onboarding'
        : '/notice-closed';
    }

    if (reservation.isStandBy === true) {
      if (stbPallSeat) {
        return this.validatePassengersCki();
      } else {
        if (isStbEmployee(this.reservation)) {
          return '/stb/employeeStbExit';
        } else {
          return '/stb/noticeBoardingpass';
        }
      }
    } else if (lookUp.length > 1) {
      return '/choose-passagers';
    } else {
      this._globalService.isMultiFlights = lookUp.length > 1;
      if (this.validateToMenu()) {
        this.onSelectAllPaseengers(true);
        if (this.reservation.codeShare) {
          return '/seamless/menu';
        } else {
          return 'rbmenuPassengerSelection';
        }
      } else {
        // this.getBenefits(this.reservation.passengers[0],this.reservation)
        // this.getAssosiateFFN(this.reservation.passengers[0],this.reservation)
        return '/choose-passagers';
      }
    }
  }

  private navigateWithFEMCheck(targetRoute: string): void {
    const passengers = this._passengerService.getPassengerSelection();
    const femFlagEnabled = this._adminService.admin?.SHOW_FEM ?? false;
    const { show, evaluation } = evaluateFemModal(
      this.reservation?.flightSummary,
      passengers,
      femFlagEnabled
    );
    this._newRelicEventsService.trackEvent(
      NEW_RELIC_EVENT.FEM_MODAL_EVALUATION,
      buildFemMetricPayload(show, evaluation, femFlagEnabled, passengers)
    );

    if (show) {
      const modalRef = this.modalService.open(FemModalComponent, {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
      });
      modalRef.componentInstance.buttonTextKey = 'continue';
      modalRef.result.then(
        () => this._router.navigate([targetRoute]),
        () => this._router.navigate(['/'])
      );
    } else {
      this._router.navigate([targetRoute]);
    }
  }
  isDocVerifyPassengers() {
    if (this.reservation?.flightSummary.isDomestic) return true;
    return this.reservation.passengers.every((element) => {
      const scanned = element.passengerInfo?.passport?.passportScanned;
      const hasDocv = element.hasDOCV;
      const docvMissing = element.missingCheckinOptionalFields?.includes('DOCV');
      return scanned || hasDocv || !docvMissing;
    });
  }

  validatePassengersCki() {
    let route = '/choose-passagers';
    if (this.validateToMenu()) {
      this.onSelectAllPaseengers(true);
      route = 'rbmenuPassengerSelection';
    }
    return route;
  }
  showBoaringpass() {
    return false;
  }

  goHome() {
    this._router.navigate(['/']);
  }

  openModalVerifyPassport(): void {
    const modalRef = this.modalService.open(VerifyPassportModalComponent, {
      fullscreen: true,
      centered: true,
      keyboard: false,
      backdrop: false,
    });
    modalRef.componentInstance.titleError = 'modalVerPass.title';
    modalRef.componentInstance.msgError = 'modalVerPass.subtitle';
    modalRef.componentInstance.printCard = '';
    modalRef.componentInstance.codeError = '';
    modalRef.componentInstance.uuidError = '';
    modalRef.componentInstance.backgroundColorModal = 'am-blue-premium';
    modalRef.componentInstance.showButton = true;
    modalRef.componentInstance.buttonCopy = 'modalVerPass.btverify';
    modalRef.componentInstance.showIconImage = false;
    modalRef.componentInstance.colorFontButton = 'blue-font';
    modalRef.componentInstance.backGroundButton = 'search-bg';
    modalRef.componentInstance.sizeModal = 'sd';
    modalRef.componentInstance.fontWeightTitleError = '500';
    //modalRef.componentInstance.image = './assets/images/img_ver_pass.svg';
    modalRef.componentInstance.showCancelButton = false;
    modalRef.componentInstance.cancelButtonText = '';
    //this.modalRef = modalRef
  }

  validationCancel(reservation) {
    let valid = false;
    if (reservation.checkinStatus == 'CLOSED') {
      this._globalService.setReservation(reservation);
      valid = true;
    }
    return valid;
  }

  orderArray(openTrips) {
    openTrips.sort((a, b) => {
      if (a.flightSummary.departureDateTime < b.flightSummary.departureDateTime) {
        return -1;
      }
      if (a.flightSummary.departureDateTime > b.flightSummary.departureDateTime) {
        return 1;
      }
      return 0;
    });
    return openTrips;
  }

  /**
  Construye y actualiza la información de los vuelos en las reservas basándose en la respuesta del estado de los vuelos.
  Esta función itera sobre las reservas y los segmentos de vuelo, comparándolos con la información de estado de vuelo
  proporcionada. Actualiza los segmentos con nueva información, como cambios en horarios, cancelaciones y estado del vuelo.

  @param responseFlightStatus Un arreglo de objetos que contiene la información del estado de los vuelos.
  @param lookUp Un arreglo de objetos de tipo `Reservation` que representa las reservas a actualizar.
**/
  constructFlight(responseFlightStatus: any[], lookUp: Reservation[]) {
    const { currentSegment } = this.reservation.flightSummary;

    for (let [i, reservation] of lookUp.entries()) {
      for (let rfSegment of responseFlightStatus) {
        const flightStatusSeg = rfSegment.flightStatusCollection;
        const segmentStatus = flightStatusSeg[0];

        // TO DO: Comparación con OR para que se encuentre coincidencia más facil, cambiar a AND
        const findSegment = reservation?.flightSummary?.segments.find(
          (s) =>
            parseInt(segmentStatus.marketingFlightCode) === parseInt(s.marketingFlightCode) ||
            s.segmentCode === segmentStatus.segmentCode
        );

        if (findSegment) {
          // Si el status no indica afectación, comparar tiempos estimados vs originales
          if (!['Delayed', 'Early', 'Cancelled'].includes(segmentStatus.status)) {
            const estimated = new Date(segmentStatus.estimatedDepartureTime).getTime();
            const original = new Date(segmentStatus.originalDepartureTime).getTime();
            if (estimated && original && estimated !== original) {
              segmentStatus.status =
                estimated > original ? IROPS_STATUS.DELAYED : IROPS_STATUS.EARLY;
            }
          }
          segmentStatus.status = this.validStatusIrops(segmentStatus.status);
          findSegment.isChangeOag =
            segmentStatus?.status === IROPS_STATUS.DELAYED ||
            segmentStatus?.status === IROPS_STATUS.EARLY;
          findSegment.isCancelOag = segmentStatus?.status === IROPS_STATUS.CANCELLED;

          const fNInfo = {
            arrivalDateTime: segmentStatus?.estimatedArrivalTime || '',
            departureDateTime: segmentStatus?.estimatedDepartureTime || '',
            flightNumber: segmentStatus?.marketingFlightCode || '',
            originalDepartureTime: segmentStatus?.originalDepartureTime,
            originalArrivalTime: segmentStatus?.originalArrivalTime,
            status: this.validStatusIrops(segmentStatus?.status),
            departureDifferenceInMinutes: segmentStatus?.departureDifferenceInMinutes || 0,
          };

          // Recalcular departureDateTime como PNR + departureDifferenceInMinutes
          if (
            findSegment.departureDateTime &&
            segmentStatus?.departureDifferenceInMinutes != null
          ) {
            const pnrDeparture = moment(findSegment.departureDateTime).clone();
            const adjustedDeparture = pnrDeparture.add(
              segmentStatus.departureDifferenceInMinutes,
              'minutes'
            );
            fNInfo.departureDateTime = adjustedDeparture.format('YYYY-MM-DDTHH:mm:ss');
          }

          // Recalcular arrivalDateTime como PNR + arrivalDifferenceInMinutes
          if (findSegment.arrivalDateTime && segmentStatus?.arrivalDifferenceInMinutes != null) {
            const pnrArrival = moment(findSegment.arrivalDateTime).clone();
            const adjustedArrival = pnrArrival.add(
              segmentStatus.arrivalDifferenceInMinutes,
              'minutes'
            );
            fNInfo.arrivalDateTime = adjustedArrival.format('YYYY-MM-DDTHH:mm:ss');
          }

          findSegment.flightsNewInfo = fNInfo;

          if (currentSegment.segmentCode == findSegment.segmentCode) {
            currentSegment.flightsNewInfo = fNInfo;
            currentSegment.flightStatus = fNInfo.status;
            this.reservation.flightSummary.boardingGate = segmentStatus?.boardingGate || null;

            if (
              fNInfo.departureDateTime &&
              (fNInfo.status === IROPS_STATUS.DELAYED || fNInfo.status === IROPS_STATUS.EARLY)
            ) {
              this.reservation.flightSummary.departureTime = fNInfo.departureDateTime.includes('T')
                ? fNInfo.departureDateTime.split('T')[1].substring(0, 5)
                : this.reservation.flightSummary.departureTime;
            }
          }

          // Se actualiza el segmento que coincida
          this.reservation.flightSummary.segments = this.reservation.flightSummary.segments.map(
            (seg) => (seg.segmentCode === findSegment.segmentCode ? findSegment : seg)
          );
        }
      }

      const cuSegment = responseFlightStatus[i]?.flightStatusCollection?.find(
        (flight) => flight.segmentCode === reservation.flightSummary.segmentCode
      );

      const flightStatus = cuSegment?.status;
      const listFlightStatus = {
        [IROPS_STATUS.SCHEDULED]: FLIGHT_STATUS.ON_TIME,
        [IROPS_STATUS.DELAYED]: FLIGHT_STATUS.DELAYED,
        [IROPS_STATUS.EARLY]: FLIGHT_STATUS.DELAYED,
        [IROPS_STATUS.CANCELLED]: FLIGHT_STATUS.CANCELLED,
      };

      if (flightStatus) {
        reservation.flightSummary.flightStatus = listFlightStatus[flightStatus];
      }
    }

    this._globalService.setReservation(this.reservation);
  }

  validStatusIrops(status) {
    const listStatusAfected = [IROPS_STATUS.DELAYED, IROPS_STATUS.EARLY, IROPS_STATUS.CANCELLED];

    return listStatusAfected.includes(status) ? status : IROPS_STATUS.SCHEDULED;
  }

  /**
  Carga la información de los pasajeros en espera (standby) y los detalles del vuelo para una reserva específica.
  Esta función realiza dos solicitudes simultáneas: una para obtener la lista de pasajeros en espera y otra para obtener
  los detalles del vuelo. Luego, procesa las respuestas y actualiza la información correspondiente en la reserva.

  @param reservation Un objeto de tipo `Reservation` que representa la reserva para la cual se cargarán los datos.
  @return Una promesa que se resuelve con `true` si ambas solicitudes son exitosas y se procesan correctamente.
**/

  loadStb(reservation: Reservation) {
    return new Promise((resolve) => {
      combineLatest([
        this._apiService.getPassengerListstandby(reservation).pipe(
          catchError((err) => {
            return of(null);
          })
        ),
        this._apiService.getFlightDetails(reservation).pipe(
          catchError((err) => {
            return of(null);
          })
        ),
      ])
        .pipe(take(1))
        .subscribe({
          next: ([successListStandby, successFlightDetail]) => {
            if (successListStandby) {
              this.successGetPassengerListstandby(successListStandby);
            }
            // Se procesan independientemente: si standby falla, flightDetail igual se ejecuta
            if (successFlightDetail) {
              this.successFlightDetail(successFlightDetail);
            }
            // Siempre se resuelve la promesa, independientemente de qué servicios fallaron
            return resolve(true);
          },
          error: (err) => {
            // Fallback de seguridad: la promesa siempre se resuelve para no bloquear el flujo
            return resolve(true);
          },
          complete: () => {},
        });
    });
  }

  /**
  Procesa la respuesta exitosa de la lista de pasajeros en espera (standby) y actualiza el estado de los pasajeros.
  Esta función filtra los pasajeros en espera que coinciden con el código de reserva (PNR) actual,
  @param response La respuesta recibida del servicio que contiene la lista de pasajeros en espera.
**/

  successGetPassengerListstandby(response) {
    if (!response.passengers) {
      response.passengers = [];
    }
    const passengers = response.passengers.filter(
      (pax) => pax.reservationCode === this.reservation.pnr
    );
    const passengerToSeleccion = this._globalService
      .getPassengers()
      .filter((x) => x.paxType != PAX_TYPE.INFANT);
    if (passengers && passengers.length > 0) {
      for (let passenger of passengers) {
        const currentPassenger = passengerToSeleccion.find(
          (p) => p.passengerId === passenger.passengerId
        );
        if (currentPassenger) {
          currentPassenger.checkinStatus = true;
          currentPassenger.onPriorityCodeListOVS = true;
          this._globalService.setPassenger(currentPassenger);
        }
      }
    }
    this.reservation.flightSummary.pallTotalListed = response.totalListed;
  }

  /**
  Procesa la respuesta exitosa de los detalles de un vuelo y actualiza la información de los segmentos de la reserva.
  @param response La respuesta recibida del servicio que contiene los detalles del vuelo.
**/

  successFlightDetail(response) {
    let reponse = new FlightDetails(response);
    for (let segment of this.reservation.segments) {
      const segmentAct = reponse.bookedLegCollection.find(
        (p) => p.segmentCode == segment.segmentCode
      );
      if (segmentAct) {
        const cabinInfo = segmentAct.cabinInfoList.find((p) => p.classOfService == 'Y');
        segment.cabinInfo = cabinInfo;
        segment.flightStatus = segmentAct.flightStatus;
        this.reservation.flightSummary.boardingGate = segmentAct.departureGate;
      }
    }
  }

  openCodeInfoModal(operatingCarrier): void {
    const modalRef = this.modalService.open(AirLinesComponent, {
      centered: true,
      size: 'xl',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.operatingCarrier = operatingCarrier;

    this.subscribeReference = modalRef.closed.subscribe(
      (resp) => {
        this._router.navigate(['/home']);
      },
      (error: ErrorInt) => {},
      () => {}
    );
  }

  ngOnDestroy() {
    this._keyboardServ.destroy();
  }

  validateToMenu() {
    if (this._adminService.admin.baggageOnlyFlow) {
      return false;
    }
    const passegerList = this.reservation?.passengers.filter(
      (passenger) => passenger.hasInfant === false
    );
    return passegerList.length <= 2 && passegerList.every((el) => el.checkinStatus);
  }
  /**
  Selecciona o deselecciona a todos los pasajeros que cumplen con ciertas condiciones para el check-in.
  Esta función itera sobre una lista de pasajeros filtrada y, dependiendo del valor proporcionado,
  selecciona o deselecciona a los pasajeros que están listos para el check-in o tienen un estado de check-in activo.
  Además, asigna la selección a los infantes asociados si corresponde.

  @param value Un valor booleano que indica si se deben seleccionar (`true`) o deseleccionar (`false`) a los pasajeros.
  @return No retorna ningún valor explícito, pero actualiza el estado de selección de los pasajeros y sus infantes asociados.
**/

  onSelectAllPaseengers(value) {
    if (value == true || value == false)
      for (const passenger of this.passengerToSeleccion.filter(
        (passenger) =>
          passenger.checkinStatus === true ||
          passenger.estatusCheckin === ESTATUS_CHECKIN.READY_FOR_CHECKIN
      )) {
        passenger.isSelectedToCheckin = value;
        passenger.checkinSelected = value;
        this.assingInfant(passenger);
      }
  }

  get passengerToSeleccion() {
    return this.reservation.passengers.filter((x) => x.paxType != PAX_TYPE.INFANT);
  }
  /**
  Asigna la información de un adulto a su infante asociado en la reserva.
  @param adult Un objeto de tipo `Passenger` que representa al pasajero adulto del cual se obtendrá la información.
  @return No retorna ningún valor explícito, pero actualiza la información del infante en el servicio global.
**/
  assingInfant(adult: Passenger) {
    if (adult.hasInfant) {
      const { passengerId, passengerIds, checkinSelected } = adult;
      const infant = this.reservation.passengers.find(
        (inf) => inf.nameRefNumber === adult.passengerInfant
      );
      infant.checkinSelected = checkinSelected;
      infant.passengerId = passengerId;
      infant.passengerIds = passengerIds;
      this._globalService.setPassenger(infant);
    }
  }

  isSeamless(reservation: Reservation) {
    /**
     * Se usa WAIT_FOR_AGENT ya que no se tiene una bandera de seamless desarrollada y se tendría que solicitar a api
     * si esta bandera está en true permitira la validación de seamless de lo contrario lo debera saltar
     */
    if (this._adminService.admin.WAIT_FOR_AGENT)
      if (reservation?.flightSummary?.currentSegment?.marketingCarrier === 'AM') {
        const airline = AirLineSeamless.find(
          (airline) => airline === reservation.flightSummary.currentSegment.operatingCarrier
        );
        return !!airline;
      }
    return false;
  }

  async dispatchEligibilityIrops() {
    return lastValueFrom(
      this._iropsMicroService.eligibility(this.reservation, TypeLoading.FOOTER_LOADING)
    );
  }

  private isChildAlone(passengers): string | null {
    return verifyChildAlone(passengers) ? '/notice-child' : null;
  }

  validateVoidTicket(reservation: Reservation): boolean {
    const { segments, passengers } = reservation;
    const nonFlownStatuses: string[] = [
      CHECKIN_STATUS.CLOSED,
      CHECKIN_STATUS.IN_FLIGHT,
      CHECKIN_STATUS.FINAL,
      CHECKIN_STATUS.BOARDING,
    ];
    const activeSegments: Segment[] = segments.filter(
      (s: Segment) => !nonFlownStatuses.includes(s.windowSegmentStatus)
    );
    const segmentCodes: string[] = activeSegments.map((segment: Segment) => segment.segmentCode);
    const segLeng: number = activeSegments.length;

    return passengers.some(
      (p) =>
        p.ticketInfo?.coupons?.filter((c) => segmentCodes.includes(c.segmentCode))?.length !==
        segLeng
    );
  }

  validInternationalBlock(reservation: Reservation) {
    const blockInter = this._adminService.admin.TSA && !reservation.flightSummary.isDomestic;
    const blockInterRegions = this._adminService.admin.portPinpad;
    const segments = reservation.flightSummary.segments.filter(
      (seg) =>
        seg.windowSegmentStatus == CHECKIN_STATUS.CKI ||
        seg.windowSegmentStatus == CHECKIN_STATUS.MYB
    );
    const isBlock =
      blockInter && segments?.some((seg) => blockInterRegions.includes(seg.arrivalAirportRegion));
    return isBlock;
  }

  openModalInternationalBlocked(): void {
    const modalRef = this.modalService.open(TsaBlockerModalComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.lang = this._traslateService.currentLang.replace('-', '_');
    this.subscribeReference = modalRef.closed.subscribe((resp) => {
      this._router.navigate(['/home']);
    });
  }
  /**
   LOYATLY
   **/

  getAssosiateFFN(passenger: Passenger, reservation: Reservation) {
    this._loyatlyService.getAssosiateFFN(passenger, reservation).subscribe({
      next: (res) => {
        //let reponse = new RespBenefits(res);
      },
      error: (error) => {},
      complete: () => {},
    });
  }

  /**
   * Envía el remark de entrada al flujo IROPs si el pasajero es elegible (exchangesAllowed === true).
   * AC1: Se invoca al microservicio de remarks.
   * AC2: Si no es elegible, no se invoca.
   */
  private dispatchIropsRemarkIfEligible(): void {
    if (!this.respEligibleIrops || !this.respEligibleIrops.exchangesAllowed) {
      return;
    }

    const segmentCancelled = this.segCancelled;
    const segmentAfected = this.segAfected;
    let affectationType: string = 'MAJ';
    let action: string = 'IROPDL';

    if (segmentCancelled) {
      action = 'IROPCN';
      affectationType = 'CAN';
    } else if (segmentAfected) {
      const diffMinutes = Math.abs(
        segmentAfected?.flightsNewInfo?.departureDifferenceInMinutes || 0
      );
      const totalMinutes: number = diffMinutes;
      affectationType = totalMinutes <= 60 ? 'MIN' : 'MAJ';
    }

    this._iropsMicroService.affectationType = affectationType;

    const remarkParams = IropsMapper.buildRemarkParams(this.reservation, action, affectationType);
    this._iropsMicroService.sendIropsRemark(this.reservation, remarkParams).subscribe();
  }

  /**
   * Evaluates whether ALL non-infant passengers in the response lack passengerIds.
   * Used after the retry-enabled getViewDocuments call to determine if the blocking
   * flow (CHECKIN_ERROR modal → navigate home) should be triggered.
   * Returns false for codeShare reservations (they use passengerIdSkyteam).
   * Requirements: 3.3, 3.5
   */
  private hasNoPassengerIdsForAllPassengers(viewDocsResponse: any): boolean {
    if (this.reservation?.codeShare) {
      return false;
    }
    const passengers = viewDocsResponse?.passengers || [];
    // Filter to non-infant passengers only (Requirement 3.3)
    const nonInfantPassengers = passengers.filter((p) => p?.type !== PAX_TYPE.INFANT);
    if (!nonInfantPassengers.length) {
      return false;
    }
    // Block only when ALL non-infant passengers lack valid passengerIds AND passengerIdSkyteam
    return nonInfantPassengers.every((p) => {
      const hasValidIds =
        Array.isArray(p?.passengerIds) &&
        p.passengerIds.length > 0 &&
        p.passengerIds.some((entry) => !!entry?.id);
      return !hasValidIds && !p?.passengerIdSkyteam;
    });
  }

  /**
   * Calls getViewDocuments with automatic retry support, replacing the direct
   * RequiredDocumentsService.getViewDocuments call. Stores successful passenger ID
   * data in the PassengerIdMapService for downstream fallback usage.
   *
   * @param reservation The reservation to fetch documents for
   * @param handleSuccess Callback invoked with the raw response on success
   * @returns Promise<boolean> - true when call completes (success or error)
   */
  private async getViewDocumentsWithRetry(
    reservation: Reservation,
    handleSuccess?: (res: any) => void
  ): Promise<boolean> {
    let response: any;
    try {
      response = await lastValueFrom(
        this._getViewDocumentsRetryService.getViewDocumentsWithRetry(reservation)
      );
    } catch (error) {
      // Requirement 3.6: On service/network error, treat as all passengers missing IDs
      this.shouldBlockByMissingPassengerIds = true;
      return true;
    }
    try {
      if (handleSuccess) {
        handleSuccess(response);
      }
      this.storePassengerIdsToMap(response, reservation);
    } catch (error) {
      // Processing error — do not block, preserve existing behavior
    }
    return true;
  }

  /**
   * Stores resolved passenger IDs from a getViewDocuments response into the
   * PassengerIdMapService for session-level backup.
   */
  private storePassengerIdsToMap(response: any, reservation: Reservation): void {
    try {
      const viewDocs = new ViewDocuments(response);
      if (!viewDocs?.passengers?.length) {
        return;
      }
      const entries = viewDocs.passengers
        .filter((p) => Array.isArray(p.passengerIds) && p.passengerIds.length > 0)
        .map((p) => {
          const currentSegmentCode = reservation?.flightSummary?.currentSegment?.segmentCode || '';
          const passengerId =
            p.passengerIds.find((ids) => ids.segmentCode === currentSegmentCode)?.id ||
            p.passengerIds[0]?.id ||
            '';
          return {
            passengerNameNumber: p.passengerNameNumber,
            passengerId,
            passengerIds: p.passengerIds,
          };
        });
      if (entries.length > 0) {
        this._passengerIdMapService.upsert(entries);
      }
    } catch (error) {
      // Silently fail — do not block user flow
    }
  }

  /**
   * Si ningún pasajero de la reserva trae passengerIds,
   * se muestra modal de “acude a mostrador” y se termina el flujo actual.
   */
  private handleMissingPassengerIdsBlock(): boolean {
    if (!this.shouldBlockByMissingPassengerIds) {
      return false;
    }
    this._message
      .errorNoCkin(
        {
          typesError: TypesErrors.CHECKIN_ERROR,
          error: {
            message: '',
          },
        },
        null,
        TypesErrors.CHECKIN_ERROR,
        messageNoCkn,
        '',
        false
      )
      .finally(() => {
        this._router.navigate(['']);
      });
    this.ngOnDestroy();
    return true;
  }

  /**
   * En flujo reducido, valida que al menos un pasajero tenga check-in realizado
   * o esté listo para check-in antes de navegar a /choose-passagers.
   * Si ninguno cumple, muestra modal de error y redirige al home.
   * @returns true si se bloqueó la navegación, false si puede continuar.
   */
  private handleBaggageOnlyNoEligiblePassengers(urlDirect: string): boolean {
    if (!this._adminService.admin.baggageOnlyFlow || urlDirect !== '/choose-passagers') {
      return false;
    }

    const hasEligiblePassenger = this.reservation.passengers.some((p) => p.checkinStatus === true);

    if (hasEligiblePassenger) {
      return false;
    }

    this._message
      .errorNoCkin(
        { typesError: TypesErrors.BAGGAGE_ONLY_NO_CKI, error: null },
        null,
        TypesErrors.BAGGAGE_ONLY_NO_CKI,
        messageBaggageOnlyNoCki
      )
      .finally(() => {
        this._router.navigate(['']);
      });
    return true;
  }

  /**
   * En flujo reducido, valida si el pasajero está en un punto de conexión
   * (primer segmento ya volado en un itinerario con múltiples segmentos).
   * CI-22300: No bloquear en conexión — la elegibilidad real se valida downstream
   * vía BagtagEligibilityResolverService (respeta shortBaggageDrop).
   * Solo bloquea si NO hay pasajeros con check-in completo en conexión
   * y NO es un escenario potencial de shortBaggageDrop.
   * @returns true si se bloqueó la navegación, false si puede continuar.
   */
  private handleBaggageOnlyConnectionRestriction(urlDirect: string): boolean {
    if (!this._adminService.admin.baggageOnlyFlow || urlDirect !== '/choose-passagers') {
      return false;
    }

    const segments = this.reservation?.flightSummary?.segments;
    if (!segments || segments.length < 2) {
      return false;
    }

    const firstSegmentStatus = segments[0]?.windowSegmentStatus;
    const isInConnection = ['CLOSED', 'IN_FLIGHT', 'MYB'].includes(firstSegmentStatus);

    if (!isInConnection) {
      return false;
    }

    // CI-22300: Allow passage for passengers with checked-in status in connections.
    // The downstream bagtag eligibility check (BagtagEligibilityResolverService)
    // will properly validate shortBaggageDrop and hasPendingBagTags.
    const hasCheckedInPassenger = this.reservation.passengers.some((p) => p.checkinStatus === true);

    if (hasCheckedInPassenger) {
      return false;
    }

    this._message
      .errorNoCkin(
        { typesError: TypesErrors.BAGGAGE_ONLY_NO_BAGS, error: null },
        null,
        TypesErrors.BAGGAGE_ONLY_NO_BAGS,
        messageBaggageOnlyNoBags
      )
      .finally(() => {
        this._router.navigate(['']);
      });
    return true;
  }

  private openHavanaBlockModal(): void {
    const modalRef = this.modalService.open(HavanaBlockModalComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.closed.subscribe(() => {
      this._router.navigate(['/']);
    });
  }
}
